import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table,
  Popconfirm,
  notification,
  Tabs,
  InputNumber,
  Tag,
  Checkbox,
  Switch,
  Select,
} from "antd";
import {
  DeleteFilled,
  ExportOutlined,
  PlusCircleOutlined,
  SyncOutlined,
  BankOutlined,
} from "@ant-design/icons";
import api from "../Services/AxiosInstance";
import "../Pages/CSS/DonnesBases.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
//import { AdherentsService } from "../Services/AdherentsService";
import TabPane from "antd/es/tabs/TabPane";
import { AdherentsService } from "../Services/AdherentsService";
import { Link } from "react-router-dom";
const { Title } = Typography;
const generateDashes = (maxLength) => "_ ".repeat(maxLength).trim();
const Adherents = () => {
  const initialTableData = [];
  const initialNewPrestation = {
    adr: "",
    age_majorite: "",
    age_retraite: "",
    assurance: "",
    categ: "",
    codeadht: "",
    compte: "",
    compte_assur: "",
    compte_soc_mere: "",
    contact: "",
    date_adhesion: "",
    datecreation: "",
    delai_rappel_cotis: "",
    delai_suspension_cotis: "",
    delai_suspension_optique: "",
    email: "",
    intitule: "",
    ipress: "",
    lettrage: "",
    montant_cotis_mut: "",
    montant_cotis_pat: "",
    montant_cotis_sal: "",
    ninea: "",
    numcss: "",
    regul_system: "",
    secteur_activite: "",
    seuil_conso: "",
    seuil_endet: "",
    suspension_adht: "",
    tel_contact: "",
    tel_fixe: "",
    type_soc: "",
    ticket_moderateur: "",
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [secteurs, setSecteurs] = useState([]);
  const [typeDocuments, setTypeDocuments] = useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [isIntituleFilled, setIsIntituleFilled] = useState(false);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);
  const [form] = Form.useForm();
  const [activateCodeAdht, setActivateCodeAdht] = useState(true);
  //const adherentsService = new AdherentsService();
  const adherentsService = new AdherentsService();

  useEffect(() => {
    setLoading(true);
    adherentsService
      .getAllAdherents() // Ajoutez les parenthèses pour appeler la fonction
      .then((data) => {
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const columnsDoc = [
    {
      title: 'Code',
      dataIndex: 'typedoc',
      key: 'typedoc',
    },
    {
      title: 'Type Document',
      dataIndex: 'libdoc',
      key: 'libdoc',
    },
    {
      title: 'Autorisé',
      dataIndex: 'actif',
      key: 'actif',
      align: 'center',
      render: (actif, record) => (
        <Checkbox
          checked={actif}
          onChange={(e) => {
            const updatedData = typeDocuments.map(item =>
              item.typedoc === record.typedoc ? { ...item, actif: e.target.checked } : item
            );
            setTypeDocuments(updatedData);
          }}
        />
      ),
    },
  ];

  const fetchDocAutorises = async (codeadht) => {
    try {
      const data = await adherentsService.getAllDocAutorises(codeadht);
      setTypeDocuments(data);

    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };

  const handleUpdate = async () => {
    try {
      if (selectedRowData) {
        const payload = {
          ...selectedRowData,
          typeDocuments, // Ajoute la liste des documents autorisés au payload
        };
        await adherentsService.updateAdherents(payload);
        const updatedData = await adherentsService.getAllAdherents();
        setTableData(updatedData);
        setSelectedRowData(null);
        notification.success({
          message: "Modification réussie",
          description: "l'adhérent a été modifié avec succès.",
        });
      }
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de l'adhérent",
      });
    }
  };


  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createJounal = async () => {
    try {
      // Récupérer toutes les valeurs du formulaire
      const values = await form.validateFields();
      console.log(values);

      const compteStr = String(newPrestation.compte).padStart(3, '0');
      const lastThreeDigits = compteStr.slice(-3);



      // Fusionner les valeurs récupérées avec l'état newPrestation
      const payload = {
        ...newPrestation, // Inclut tous les champs de newPrestation
        ...values,
      };

      // Envoyer les données au service d'adhérents
      await adherentsService.addAdherents(payload);

      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData = await adherentsService.getAllAdherents();
      setTableData(updatedData);

      notification.success({
        message: "Ajout réussie",
        description: "L'adhérent a été ajouté avec succès.",
      });
      form.resetFields();

      // Masquer le formulaire après l'ajout

    } catch (error) {
      notification.error({
        message: "Erreur",
        description: "Erreur lors de l'ajout de l'adhérent.",
      });
    }
  };


  // Ensuite, dans votre fonction handleSave, appelez la fonction createJounal :
  const handleSave = () => {
    createJounal();
    // Réinitialiser l'état ou effectuer d'autres actions si nécessaire
  };

  const handleDelete = async (compte) => {
    try {
      await adherentsService.deleteAdherents(compte);
      // Suppression réussie, mettre à jour les données et notifier
      const updatedData = await adherentsService.getAllAdherents();
      setTableData(updatedData);
      setSelectedRowData(null);
      notification.success({
        message: "Suppression réussie",
        description: "La prestation a été supprimée avec succès.",
      });
    } catch (error) {
      // Gérer les erreurs côté frontend
      console.error("Erreur lors de la suppression de la prestation :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la suppression de la prestation.",
      });
    }
  };

  const handleRowClick = (record) => {
    setActivateCodeAdht(true);
    setSelectedRowData(record);
    fetchDocAutorises(record.codeadht);
    setShowCreateForm(false); // Affiche le formulaire de modification lorsqu'une ligne est sélectionnée
  };


  const handleNew = () => {
    setActivateCodeAdht(false);
    setShowCreateForm(true);
    setSelectedRowData(null);

    const lastCompte = tableData.length > 0 ? tableData[tableData.length - 1].compte : 0;

    const existingCodes = tableData
      .map((item) => parseInt(item.codeadht))
      .filter((code) => !isNaN(code));

    const maxCode = Math.max(...existingCodes, 0);

    // Formatage de codeadht pour ajouter un zéro devant si c'est de 0 à 9
    const lastCodeAdht = tableData.length > 0 ? tableData[tableData.length - 1].codeadht : 0;
    const newCodeAdht = (parseInt(lastCodeAdht) + 1).toString().padStart(tableData[0]?.codeadht.length || 3, '0');

    setNewPrestation({
      codeadht: newCodeAdht,
      // compte: (parseInt(lastCompte) + 1).toString(),
      compte: (parseInt(lastCompte) + 1).toString().padStart(tableData[0]?.codeadht.length || 3, '0'),

    });
  };


  useEffect(() => {
    if (tableData.length > 0) {
      handleNew();
    }
  }, [tableData]);

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };

  const handleResetAll = async () => {
    try {
      const updatedData = await adherentsService.getAllAdherents(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) { }
  };

  const handleIntituleChange = (value) => {
    setNewPrestation({
      ...newPrestation,
      intitule: value,
    });
    setIsIntituleFilled(value.trim() !== ""); // Vérifie si le champ est rempli
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return ""; // Retourne une chaîne vide si le numéro est vide

    // Enlève tous les caractères non numériques
    const cleanedNumber = phoneNumber.replace(/\D/g, "");

    // Applique le format attendu
    const formattedNumber = cleanedNumber
      .replace(/^(.{2})(.{3})(.{2})(.{2})/, "$1 $2 $3 $4") // Formatage
      .trim(); // Supprime les espaces au début et à la fin

    return formattedNumber;
  };


  const handleExport = () => {
    const exportData = tableData.map((item) => {
      const formattedItem = {};

      // Parcourez chaque clé dans l'objet pour ajouter les données au format exporté
      Object.keys(item).forEach((key) => {
        let value = item[key];

        // Si la valeur est une date, formatez-la
        if (moment(value, moment.ISO_8601, true).isValid()) {
          value = moment(value).format("DD-MM-YYYY");
        }

        // Ajoutez chaque propriété à l'objet exporté
        formattedItem[key] = value;
      });

      return formattedItem;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Adherents");

    XLSX.writeFile(workbook, "export_adherents.xlsx");
  };


  useEffect(() => {
    // Charger les secteurs d'activité depuis l'API
    api
      .get("/Adherent/Secteurs/list")
      .then((response) => {
        setSecteurs(response.data); // Mettre à jour le state avec les données reçues
      })
      .catch((error) => {
        // Gérer les erreurs de requête
        console.error("Erreur lors du chargement des secteurs:", error);
      });
  }, []);

  const defaultSelectedValue = "";

  // Ajoute cette fonction utilitaire dans ton composant Adherents (avant le return)
  const updateCodeAdhtAndCompte = (value) => {
    // Permet la saisie libre (2 ou 3 chiffres, pas de restriction sur codeadht)
    const codeadht = value.replace(/\D/g, '').slice(0, 3); // max 3 chiffres, mais libre
    // Pour la concaténation, complète à gauche avec un zéro seulement si longueur = 2
    let codeadhtForCompte = codeadht;
    if (codeadht.length === 2) {
      codeadhtForCompte = '0' + codeadht;
    }
    // Si longueur 3, ne change rien ; si <2, compte vide
    const compte = codeadht.length >= 2 ? '463' + codeadhtForCompte : '';
    setNewPrestation((prev) => ({
      ...prev,
      codeadht, // garde la saisie utilisateur telle quelle
      compte,
    }));
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "codeadht",
      key: "codeadht",
      ellipsis: true,
      width: "15px",
      align: "center",
      render: (text) => <strong>{text || " "}</strong>, // Remplacer null/undefined par une chaîne vide
      sorter: (a, b) => (String(a.codeadht) || "").localeCompare(String(b.codeadht) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Libellé",
      dataIndex: "intitule",
      key: "intitule",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left" }}>{text || " "}</div>
      ),
      ellipsis: true,
      width: "35px",
      sorter: (a, b) => (String(a.intitule) || "").localeCompare(String(b.intitule) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
      ellipsis: true,
      align: "center",
      width: "20px",
      render: (text) => text || " ", // Remplacer null/undefined par une chaîne vide
      sorter: (a, b) => (String(a.compte) || "").localeCompare(String(b.compte) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Créer le",
      dataIndex: "datecreation",
      key: "datecreation",
      ellipsis: true,
      align: "center",
      width: "20px",
      render: (text) => text && moment(text).format("DD/MM/YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.datecreation).getTime();
        const valueB = new Date(b.datecreation).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "Créer par",
      dataIndex: "created_by",
      key: "created_by",
      ellipsis: true,
      align: "center",
      width: "20px",
      render: (text) => text || " ", // Remplacer null/undefined par une chaîne vide
      sorter: (a, b) => (String(a.compte) || "").localeCompare(String(b.compte) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Etat",
      width: "15px",
      align: "center",
      dataIndex: "suspension_adht",
      key: "suspension_adht",
      ellipsis: true,
      render: (text, record) => (
        <Tag color={record.suspension_adht ? "red" : "green"}>
          {record.suspension_adht ? "Suspendu" : "Actif"}
        </Tag>
      ),
      sorter: (a, b) => (a.suspension_adht === b.suspension_adht ? 0 : a.suspension_adht ? 1 : -1),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      align: "center",
      width: "5px",
      ellipsis: true,
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.compte)}
          okText="Oui"
          cancelText="Non"
        >
          <DeleteFilled style={{ border: "none", fontSize: "16px", color: "red" }} />
        </Popconfirm>
      ),
    },
  ];


  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <BankOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
          }}
        >
          Adhérents
        </span>
        <span
          style={{
            marginLeft: 12,
            background: "rgba(255, 255, 255, 0.2)",
            padding: "4px 12px",
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 500,
            color: "#fff",
          }}
        >
          {filteredData.length}
        </span>
      </div>
      {/*  <Card  > */}
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={14}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col
                span={9}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                {/*  barre de recherche */}
                <Input
                  placeholder="Rechercher..."
                  bordered={false}
                  style={{ borderBottom: "1px solid #ccc" }}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={(e) => handleSearch(e.target.value)}
                />
              </Col>
              <Col
                span={15}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* Vos boutons d'export et d'actualisation */}
                <Space>
                  <Button
                    className="buttonExport"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  <Link to={`/fichiers/societes`}>
                    {" "}
                    <Button icon={<PlusCircleOutlined />}>
                      Demande Adhésion
                    </Button>
                  </Link>

                  <Button className="buttonRefresh" onClick={handleResetAll} icon={<SyncOutlined />}>
                    Actualiser
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          <Table
            // style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
            className="custom-header1-table"
            rowClassName={(record) =>
              selectedRowData && record.codeadht === selectedRowData.codeadht ? "selected-row" : ""
            }
            showSorterTooltip={false}
            bordered
            pagination={{
              pageSizeOptions: ["5", "10", "15", "20", "50", "100"], // Options disponibles pour la pagination
              showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
              pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
              onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
            }}

            scroll={{
              x: true,
            }}
            style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
            // size='small'
            columns={columns}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}
          />
        </Col>

        <Col xs={24} xl={10}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title
                    level={4}
                    style={{ margin: 0, marginLeft: "15px", color: "#ffffff" }}
                  >
                    {" "}
                    Nouvel Adherent
                  </Title>
                </div>
              }
            >
              <Form layout="vertical" form={form} size="small">
                <Tabs defaultActiveKey="1">

                  <TabPane tab="Informations Générales" key="1">

                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Code adhérent</strong>}
                        // name="codeadht"
                        >
                          <Input
                            maxLength={tableData[0]?.codeadht?.length === 3 ? 3 : 2} // Limite la saisie à 2 ou 3 chiffres
                            minLength={2}
                            value={newPrestation.codeadht}
                            onChange={(e) => updateCodeAdhtAndCompte(e.target.value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Compte</strong>}
                        >
                          <Input
                            readOnly
                            value={newPrestation.compte}
                            onChange={(e) =>
                              setNewPrestation({
                                ...newPrestation,
                                compte: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          name="compte_soc_mere"
                          label={<strong>Cpte Société Mère</strong>}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Téléphone fixe</strong>}
                          name="tel_fixe"
                        >
                          <Input
                            addonBefore="+221"
                            placeholder={generateDashes(9)}
                            maxLength={9}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item
                          label="Libellé"
                          name="intitule"
                          rules={[
                            {
                              required: true,
                              message: "Veuillez remplir le champs",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item
                          label={<strong>Adresse adhérent</strong>}
                          name="adr"
                          rules={[
                            {
                              required: true,
                              message: "Veuillez entrer l'intitulé",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      {/*  <Col span={12}>
          <Form.Item label={<strong>Cotisation Mutuelle</strong>} name="montant_cotis_mut">
            <InputNumber style={{width:'100%'}} />
          </Form.Item>
        </Col> */}
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Cotisation IPM Patronale</strong>}
                          name="montant_cotis_pat"
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Cotisation IPM Salariale</strong>}
                          name="montant_cotis_sal"
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Seuil Consommation</strong>}
                          name="seuil_conso"
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Seuil Endettement</strong>}
                          name="seuil_endet"
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Seuil Autres</strong>}
                          name="seuil_autres"
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Taux Cotisation</strong>}
                          name="taux_cotis"
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Plafond</strong>}
                          name="plafond"
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                    </Row>

                  </TabPane>
                  <TabPane tab="Autres Infos" key="2">

                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          name="age_majorite"
                          initialValue={"21"}
                          label={<strong>Age Majorité Enfant</strong>}
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item
                          name="age_retraite"
                          initialValue={"60"}
                          label={<strong>Age Retraite Participant</strong>}
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item
                          name="delai_suspension_optique"
                          initialValue={"730"}
                          label={
                            <strong>Délai Susp.Optique(jrs)</strong>
                          }
                        >
                          <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="ninea" label={<strong>Ninea</strong>}>
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="numeroCSS"
                          label={<strong>Numéro CSS</strong>}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="secteurActivite"
                          label={<strong>Secteur d'activité</strong>}
                        >
                          <Select defaultValue={defaultSelectedValue}>
                            <Select.Option value="">
                              Sélectionner un secteur
                            </Select.Option>
                            {secteurs.map((secteur) => (
                              <Select.Option
                                key={secteur.code}
                                value={secteur.code}
                              >
                                {secteur.libelle}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item
                          name="compte_assur"
                          label={<strong>Compte Assurance</strong>}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          name="assurance"
                          label={<strong>Soumis à l'assurance</strong>}
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          name="ticket_moderateur"
                          label={<strong>Paiement Ticket Modérateur</strong>}
                        >
                          <Checkbox />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Title style={{ fontSize: "16px" }}>Point Focal</Title>
                      <Col span={24}>
                        <Form.Item
                          label={<strong>Prénom & Nom</strong>}
                          name="contact"
                          rules={[
                            {
                              required: true,
                              message: "Veuillez entrer l'intitulé",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          label={<strong>Téléphone</strong>}
                          name="tel_contact"
                          rules={[
                            {
                              required: true,
                              message: "Veuillez entrer le numéro de téléphone",
                            },
                          ]}
                        >
                          <Input
                            addonBefore="+221"
                            placeholder={generateDashes(9)}
                            maxLength={9}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label={<strong>Email</strong>} name="email">
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          label={
                            <strong>Régul. Systématique (Frais Mdcx.)</strong>
                          }
                          name="regul_system"
                          valuePropName="checked"
                        >
                          <Checkbox />
                        </Form.Item>
                      </Col>
                    </Row>

                  </TabPane>


                </Tabs>


                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      onClick={() => setShowCreateForm(false)}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      //  htmlType="submit"
                      onClick={handleSave}
                      style={{
                        backgroundColor: "#010f1c",
                        color: "white",
                      }}
                    >
                      Enregistrer
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title
                    level={4}
                    style={{ margin: 0, color: "#ffffff", marginLeft: "15px" }}
                  >
                    Modifier Adherent
                  </Title>
                </div>
              }
            >
              <Tabs defaultActiveKey="1">
                <TabPane tab="Informations Générales" key="1">
                  <Form layout="vertical" form={form} size="small">
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item label="Code adhérent">
                          <Input
                            readOnly={activateCodeAdht}
                            value={
                              selectedRowData ? selectedRowData.codeadht : tableData.length > 0 ? String(Math.max(...tableData.map(item => parseInt(item.codeadht))) + 1) : ""
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                compte: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="Compte">
                          <Input
                            readOnly={activateCodeAdht}
                            value={
                              selectedRowData ? selectedRowData.compte : ""
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                compte: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="Cpte Société Mère">
                          <Input
                            value={
                              selectedRowData
                                ? selectedRowData.compte_soc_mere
                                : ""
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                compte_soc_mere: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item label="Statut">
                          <Switch
                            checked={
                              selectedRowData
                                ? !selectedRowData.suspension_adht
                                : false
                            }
                            onChange={(checked) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                suspension_adht: !checked,
                              })
                            }
                            checkedChildren="Actif"
                            unCheckedChildren="Suspendu"
                            style={{
                              backgroundColor:
                                selectedRowData &&
                                  !selectedRowData.suspension_adht
                                  ? "#52c41a"
                                  : "#f5222d",
                            }}
                            disabled={!selectedRowData} // Désactive le Switch si aucune ligne n'est sélectionnée
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label="Régul. Systématique (Frais Mdcx.)"
                          valuePropName="checked"
                        >
                          <Checkbox
                            checked={
                              selectedRowData
                                ? selectedRowData.regul_system
                                : false
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                regul_system: e.target.checked,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item label="Libellé adhérent">
                          <Input
                            value={
                              selectedRowData ? selectedRowData.intitule : ""
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                intitule: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item label="Adresse adhérent">
                          <Input
                            value={selectedRowData ? selectedRowData.adr : ""}
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                adr: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item label="Téléphone fixe" >

                          <Input
                            addonBefore="+221"
                            maxLength={9}
                            value={formatPhoneNumber(
                              selectedRowData ? selectedRowData.tel_fixe : ""
                            )}
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                tel_fixe: e.target.value.replace(/\s/g, ""),
                              })
                            }
                          />

                        </Form.Item>
                      </Col>
                      {/*   <Col span={12}>
                        <Form.Item label="Cotisation Mutuelle">
                          <InputNumber
                            value={
                              selectedRowData
                                ? selectedRowData.montant_cotis_mut
                                : ""
                            }
                            style={{ width: "100%" }}
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                montant_cotis_mut: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col> */}
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item label="Cotisation IPM Patronale">
                          <InputNumber
                            value={selectedRowData ? selectedRowData.montant_cotis_pat : ""}
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                montant_cotis_pat: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label="Cotisation IPM Salariale">
                          <InputNumber
                            value={selectedRowData ? selectedRowData.montant_cotis_sal : ""}
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                montant_cotis_sal: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item label="Seuil Consommation">
                          <InputNumber
                            value={selectedRowData ? selectedRowData.seuil_conso : ""}
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                seuil_conso: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item label="Seuil Endettement">
                          <InputNumber
                            value={selectedRowData ? selectedRowData.seuil_endet : ""}
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                seuil_endet: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item name="seuilAutres" label="Seuil Autres">
                          <InputNumber
                            value={selectedRowData ? selectedRowData.montant_cotis_mut : ""}
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                montant_cotis_mut: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="taux_cotis" label="Taux Cotisation">
                          <InputNumber
                            value={selectedRowData ? selectedRowData.taux_cotis : ""}
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                taux_cotis: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item name="plafond" label="Plafond">
                          <InputNumber
                            value={selectedRowData ? selectedRowData.plafond : ""}
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                plafond: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                  </Form>
                </TabPane>
                <TabPane tab="Autres Infos" key="2">
                  <Form layout="vertical" size="small">
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item label="Ninea">
                          <Input
                            value={selectedRowData ? selectedRowData.ninea : ""}
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                ninea: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="Numéro CSS">
                          <Input
                            value={
                              selectedRowData ? selectedRowData.numcss : ""
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                numcss: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="Secteur d'activité">
                          <Input
                            value={
                              selectedRowData
                                ? selectedRowData.secteur_activite
                                : ""
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                secteur_activite: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item label="Age Majorité Enfant">
                          <InputNumber
                            value={
                              selectedRowData
                                ? selectedRowData.age_majorite
                                : ""
                            }
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                age_majorite: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="Age Retraite Participant">
                          <InputNumber
                            value={
                              selectedRowData
                                ? selectedRowData.age_retraite
                                : ""
                            }
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                age_retraite: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="Délai Susp.Optique(jrs)">
                          <InputNumber
                            value={
                              selectedRowData
                                ? selectedRowData.delai_suspension_optique
                                : ""
                            }
                            style={{ width: "100%" }}
                            onChange={(value) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                delai_suspension_optique: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={16}>
                      <Col span={8}>
                        <Form.Item
                          //   name="assurance"
                          label="Soumis à l'assurance"
                          valuePropName="checked"
                        >
                          <Checkbox
                            checked={
                              selectedRowData
                                ? selectedRowData.assurance
                                : false
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                assurance: e.target.checked,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="Compte Assurance">
                          <Input
                            value={
                              selectedRowData
                                ? selectedRowData.compte_assur
                                : ""
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                compte_assur: e.target.value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          // name="ticket_moderateur"
                          label="Paiement Ticket Modérateur"
                          valuePropName="checked"
                        >
                          <Checkbox
                            checked={
                              selectedRowData
                                ? selectedRowData.ticket_moderateur
                                : false
                            }
                            onChange={(e) =>
                              setSelectedRowData({
                                ...selectedRowData,
                                ticket_moderateur: e.target.checked,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Row gutter={16}>
                        <Title
                          style={{ fontSize: "16px", paddingLeft: "10px" }}
                        >
                          Point Focal
                        </Title>
                        <Col span={24}>
                          <Form.Item label="Prénom & Nom">
                            <Input
                              style={{ width: "100%" }}
                              value={
                                selectedRowData ? selectedRowData.contact : ""
                              }
                              onChange={(e) =>
                                setSelectedRowData({
                                  ...selectedRowData,
                                  contact: e.target.value,
                                })
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col span={12}>
                          <Form.Item label="Téléphone ">

                            <Input
                              addonBefore="+221"
                              maxLength={9}
                              value={formatPhoneNumber(
                                selectedRowData
                                  ? selectedRowData.tel_contact
                                  : ""
                              )}
                              onChange={(e) =>
                                setSelectedRowData({
                                  ...selectedRowData,
                                  tel_contact: e.target.value.replace(
                                    /\s/g,
                                    ""
                                  ),
                                })
                              }
                            />

                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item label="Email">
                            <Input
                              value={
                                selectedRowData ? selectedRowData.email : ""
                              }
                              onChange={(e) =>
                                setSelectedRowData({
                                  ...selectedRowData,
                                  email: e.target.value,
                                })
                              }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Row>
                  </Form>{" "}
                </TabPane>
                <TabPane tab="Documents Autorisés" key="3">
                  <h3>Documents autorisés aux participants depuis les applications mobile et web .</h3>
                  <h4 style={{ textAlign: 'center', color: 'blue' }}>
                    {selectedRowData?.intitule}
                  </h4>
                  {/* <br></br> */}
                  <hr style={{ border: "2px solid black" }} />
                  <Table
                    columns={columnsDoc}
                    dataSource={typeDocuments}
                    size="small"
                    bordered
                    pagination={false}
                    rowKey={(record) => record.typedoc}
                    style={{ marginTop: "5px", marginBottom: "20px" }}
                    scroll={{ x: true }}
                  />
                </TabPane>
              </Tabs>
              <Form layout="vertical">
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleNew}
                      style={{
                        backgroundColor: "transparent",
                        color: "#010f1c",
                        borderColor: "#010f1c",
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      onClick={handleUpdate}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Modifier
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
      {/* </Card> */}
    </div>
  );
};

export default Adherents;
